import React from 'react';
import { AboutPageLayout } from '../Layout';
import styles from './Why.module.scss';

export const WhyMainSection = () => (
  <AboutPageLayout
    isMain
    leftContent={
      <div className={styles.leftSection}>
        <div className={styles.mainSection_1}>Wh</div>
        <div className={styles.mainSection_2}>TransparenTerra?</div>
        <div className={styles.mainSection_3}>y</div>
      </div>
    }
    rightContent={null}
  />
);
